import { LoginPage } from '@ppay/client'

import { routes } from '../../router'

export function Page() {
  return <LoginPage forgotPasswordLink={routes.auth.restore} signUpLink={routes.auth.signUp} />
}
